module.exports = __webpack_public_path__ + "static/media/moshi-bg.8510f9c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/ContactUs/moshi-bg.jpg
// module id = 173
// module chunks = 0